import * as React from "react";
import {CircularProgress} from 'material-ui';

const CircularProgressIndicator = () => {
    return (
        <div>
            <CircularProgress style={{display: 'table', margin: '0 auto'}} color={'#d15844'}/>
        </div>
    );
};

export default CircularProgressIndicator;


// WEBPACK FOOTER //
// ./components/common/CircularProgressIndicator.tsx